module.exports = __webpack_public_path__ + "static/media/no-dataview-data.959e15a4.svg";